import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import { DashBoardTitle } from '../../../Components/Title';

import './index.css';
import { getCNFCount } from '../../../constants/apiCalls';
import ModalService from '../../../services/ModalService';
import { handleErrorMessage } from '../../../utils/utils';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

function CNFDashboard() {
  const [isLoading, setIsloading] = useState(false);
  const [fulfilled, setFulfilled] = useState(0);
  const [open, setOpen] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    setIsloading(true);
    getCNFCount((res) => {
      const { data, success, error } = res;

      if (success) {
        setIsloading(false);

        setFulfilled(data.orderData.fulfilled_order);
        setOpen(data.orderData.open_order);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert(
          '',
          handleErrorMessage(error[0].message),
          'error',
        );
        setIsloading(false);
      }
    });
  }, []);

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id="cnf-dashboard">
              {isLoading && <CustomSpinner />}
              <Container fluid>
                <Row>
                  <Col xs={12}>
                    <div className="pageheader">
                      <DashBoardTitle dashBorardName="CNF Dashboard" />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xl={4} lg={6} md={6}>
                    <div className="cardDashboard mt-4">
                      <div className="mainTitle m-0">Open Order</div>
                      <div className="cardDashboardInner">
                        <Row className="justify-content-center">
                          <div
                            className="singleNumberBlock"
                            onClick={() => navigate('/cnf/open-orders')}
                          >
                            {open || 0}
                          </div>
                        </Row>
                      </div>
                    </div>
                  </Col>
                  <Col xl={4} lg={6} md={6}>
                    <div className="cardDashboard mt-4">
                      <span className="card_financialYear">FY 2022-23</span>
                      <div className="mainTitle m-0">Fulfilled Order</div>
                      <div className="cardDashboardInner">
                        <Row className="justify-content-center">
                          <div
                            onClick={() => navigate('/cnf/fulfilled-orders')}
                            className="singleNumberBlock"
                            style={{ color: '#545CD8' }}
                          >
                            {fulfilled || 0}
                          </div>
                        </Row>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CNFDashboard;
